// Application configuration

const config = {
  apiBaseUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  mapboxApiKey: process.env.REACT_APP_MAPBOX_API_KEY || '',
};

export default config;
